var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"links"},[(_vm.isLinkClientProposition() && _vm.linkData)?_c('client-propositions-block',{attrs:{"data-link":_vm.linkData}}):(_vm.isLinkPenalty())?_c('div',{staticClass:"penalty-block"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }